const WarningMessage = ({ children }) => {
    return (
        <div className="warningMessage">
           {children}
        </div>
    );
};

export default WarningMessage;